import type { TFunction } from 'i18next'
import { z } from 'zod'

import { SubmitBidInputSchema } from '@mntn-dev/bid-service/client'

import { isFormattedTextLengthValid } from '../refinements/formatted-text.ts'

export const SubmitBidFormValidationSchema = (
  t: TFunction<['validation', 'bids']>
) =>
  SubmitBidInputSchema.omit({ agreements: true })
    .required({ bidId: true })
    .extend({
      makerTermsAccepted: z.boolean().refine((val) => !!val, {
        message: t('bids:submit-bid-form.agreements.errors'),
      }),
      makerProjectPaymentTermsAccepted: z.boolean().refine((val) => !!val, {
        message: t('bids:submit-bid-form.agreements.errors'),
      }),
      pitch: z.string().superRefine((val, ctx) =>
        isFormattedTextLengthValid(t, t('bids:submit-bid-form.pitch.label'), {
          min: 1,
        }).refinement(val, ctx)
      ),
      amount: z.any().refine((val) => val !== undefined && val > 0, {
        message: t('bids:submit-bid-form.amount.errors.required'),
      }),
    })
